// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__7PkzU"};